// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {9665: "b8c278ade2a60691",9779: "0ee0d8df64258830",}[chunkId] + ".js"
}